import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";

export const useUploadDocuments = () => {
    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingUploadDocuments>();

    const formProps: HighRiskMerchant.UploadDocuments.OnboardingUploadDocumentsForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.UploadDocuments.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: () => {
            alert('Not implemented yet please wait for the update.');
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.UploadDocuments.useForm(formProps),
        ...data
    };
};

export default useUploadDocuments;
